/**
 * Token数据结构
 */
interface TokenData {
  access_token: string;
  refresh_token: string;
  access_expires_in: number;
  refresh_expires_in: number;
  timestamp: number;
}

/**
 * Token管理器 - 纯粹的token状态管理
 * 特性：token存储、过期检测、状态查询
 */
class TokenManager {
  private static instance: TokenManager;

  private constructor() {}

  static getInstance(): TokenManager {
    if (!TokenManager.instance) {
      TokenManager.instance = new TokenManager();
    }
    return TokenManager.instance;
  }

  /**
   * 存储token数据（包含时间戳）
   */
  setTokens(tokenData: Omit<TokenData, 'timestamp'>): void {
    const data: TokenData = {
      ...tokenData,
      timestamp: Date.now(),
    };

    uni.setStorageSync('app_token_data', JSON.stringify(data));
  }

  /**
   * 获取存储的token数据
   */
  getTokenData(): TokenData | null {
    try {
      const data = uni.getStorageSync('app_token_data');
      return data ? JSON.parse(data) : null;
    }
    catch {
      return null;
    }
  }

  /**
   * 检查access token是否即将过期（提前30秒）
   */
  shouldRefresh(): boolean {
    const tokenData = this.getTokenData();
    if (!tokenData) return false;

    const expiryTime = tokenData.timestamp + tokenData.access_expires_in * 1000;
    const shouldRefreshTime = expiryTime - 30 * 1000; // 提前30秒

    return Date.now() >= shouldRefreshTime;
  }

  /**
   * 检查refresh token是否过期
   */
  isRefreshTokenExpired(): boolean {
    const tokenData = this.getTokenData();
    if (!tokenData) return true;

    const expiryTime = tokenData.timestamp + tokenData.refresh_expires_in * 1000;
    return Date.now() >= expiryTime;
  }

  /**
   * 获取当前access token（不做网络请求）
   */
  getCurrentToken(): string | null {
    const tokenData = this.getTokenData();
    return tokenData?.access_token || null;
  }

  /**
   * 检查是否已登录
   */
  isLoggedIn(): boolean {
    const tokenData = this.getTokenData();
    return tokenData !== null && !this.isRefreshTokenExpired();
  }

  /**
   * 清除所有token数据
   */
  clear(): void {
    uni.removeStorageSync('app_token_data');
  }
}

// 导出单例实例
export const tokenManager = TokenManager.getInstance();
export default tokenManager;
